export function getDefaultStartTime() {
    let outDate = new XDate(new Date());
    return outDate.toString("yyyy-MM-dd");
}

export function getMonthStartTime() {
    let outDate = new XDate(new Date());
    return outDate.toString("yyyy-MM-01");
}

export function getDefaultEndTime() {
    let outDate = new XDate(new Date());
    return outDate.addDays(1).toString("yyyy-MM-dd");
}

export function getMonthEndTime() {
    let outDate = new XDate(new Date());
    return outDate.addMonths(1).toString("yyyy-MM-01");
}

export function formatDate(date) {
    if (date != null) {
        let outDate = new XDate(date);
        return outDate.toString("yyyy-MM-dd");
    }
}

export function formatDateTime(date) {
    if (date != null) {
        let outDate = new XDate(date);
        return outDate.toString("yyyy-MM-dd HH:mm:ss");
    }
}
export function formatDateTimeYYmm(date) {
    if (date != null) {
        let outDate = new XDate(date);
        return outDate.toString("yyyy-MM");
    }
}
export function formatDateTimeYY(date) {
    if (date != null) {
        let outDate = new XDate(date);
        return outDate.toString("yyyy");
    }
}

export function formatDateWithTT(date) {
    let outDate = new XDate(date);
    return outDate.toString("dd/MM/yyyy HH:mm:ss TT");
}


export function addOneDayForDate(date) {
    let outDate = new XDate(date);
    return outDate.addDays(1).toString("yyyy-MM-dd");
}